exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-snackbar--material{margin-top:32px;margin-bottom:32px}.v-snackbar--material .v-alert--material,.v-snackbar--material .v-snack__wrapper{border-radius:4px}.v-snackbar--material .v-snack__content{overflow:visible;padding:0}", ""]);

// exports
